import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const response = await fetch("/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        throw new Error(data?.detail || "Something went wrong. Please try again.");
      }
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="launch-root flex min-h-screen items-center justify-center px-4 text-foreground">
      <div className="launch-hero-bg" aria-hidden="true" />
      <div className="launch-orb launch-orb--one" aria-hidden="true" />
      <div className="launch-orb launch-orb--two" aria-hidden="true" />
      <div className="aa-glass-card relative z-10 w-full max-w-md space-y-6 rounded-2xl p-8 shadow-xl">
        <h1 className="aa-page-title text-2xl font-semibold text-foreground">Reset password</h1>

        {submitted ? (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly. Check your inbox (and spam folder).
            </p>
            <Link to="/login" className="text-sm text-primary hover:underline">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label className="text-xs uppercase tracking-wide text-muted-foreground">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-md border border-border bg-background/80 px-3 py-2 text-sm text-foreground/80 focus:border-primary/50 focus:outline-none"
                autoComplete="email"
                required
              />
            </div>

            {error && <p className="text-xs text-rose-400">{error}</p>}

            <Button type="submit" className="w-full uppercase tracking-wide" disabled={loading || !email}>
              {loading ? "Sending…" : "Send reset link"}
            </Button>

            <p className="text-center text-xs text-muted-foreground">
              <Link to="/login" className="hover:underline">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
